import { render } from "./TermsOfService.vue?vue&type=template&id=403f5101&bindings={}"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"
script.render = render

export default script